(() => {
  const ACK_SELECTOR = '[data-preorder-ack], [data-preorder-cart-ack]';
  const PROMO_SELECTOR = '.vw-launcher, .vw-teaser, [data-vexit]';
  const CART_ERROR = 'Tick the box above to confirm the ship date, then we will take you to checkout.';

  function isPreorderPage() {
    return !!document.querySelector('[data-preorder-panel]');
  }

  function syncPreorderPromoGuard(root = document) {
    const active = isPreorderPage();
    document.documentElement.classList.toggle('velario-preorder-page', active);
    if (!active) return;
    root.querySelectorAll?.(PROMO_SELECTOR).forEach((el) => {
      if (!(el instanceof HTMLElement)) return;
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('data-preorder-promo-suppressed', '');
    });
  }

  function panelFor(input) {
    return input.closest('[data-preorder-panel], [data-preorder-cart-panel]');
  }

  function errorRowFor(input) {
    return input.closest('[data-preorder-consent-row], .vpreorder-cart__ack, .vpreorder__ack');
  }

  function purchaseButtonFor(input) {
    const form = input.closest('form');
    if (!form) return null;
    return form.querySelector('[ref="addToCartButton"], .add-to-cart-button, button[name="add"], [data-preorder-submit]');
  }

  function clearError(input) {
    input.setCustomValidity('');
    const panel = panelFor(input);
    const error = panel?.querySelector('[data-preorder-error]');
    if (error instanceof HTMLElement) {
      error.hidden = true;
      error.textContent = '';
    }
    const row = errorRowFor(input);
    if (row instanceof HTMLElement) row.classList.remove('is-error');
  }

  function syncButton(input) {
    if (!(input instanceof HTMLInputElement) || !input.matches('[data-preorder-ack]')) return;
    const button = purchaseButtonFor(input);
    if (!(button instanceof HTMLButtonElement)) return;
    button.disabled = !input.checked;
    button.setAttribute('aria-disabled', input.checked ? 'false' : 'true');
    button.toggleAttribute('data-preorder-awaiting-ack', !input.checked);
  }

  function setState(input) {
    if (!(input instanceof HTMLInputElement)) return;
    if (input.checked) clearError(input);
    else input.setCustomValidity('');
    syncButton(input);
  }

  function requireAcknowledgment(input) {
    if (!(input instanceof HTMLInputElement) || input.checked) return true;
    const message = input.matches('[data-preorder-cart-ack]')
      ? CART_ERROR
      : 'Please check the box to confirm the pre-order terms.';
    const panel = panelFor(input);
    const error = panel?.querySelector('[data-preorder-error]');
    const row = errorRowFor(input);
    input.setCustomValidity('');
    if (error instanceof HTMLElement) {
      error.textContent = message;
      error.hidden = false;
    }
    if (row instanceof HTMLElement) row.classList.add('is-error');
    (row instanceof HTMLElement ? row : input).scrollIntoView({ behavior: 'smooth', block: 'center' });
    input.focus({ preventScroll: true });
    return false;
  }

  function initialize(root = document) {
    root.querySelectorAll?.(ACK_SELECTOR).forEach(setState);
    syncPreorderPromoGuard(root);
  }

  document.addEventListener('change', (event) => {
    if (event.target instanceof HTMLInputElement && event.target.matches(ACK_SELECTOR)) setState(event.target);
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const input = form.querySelector(ACK_SELECTOR);
    if (input instanceof HTMLInputElement && !requireAcknowledgment(input)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const stickyPreorder = target.closest('[data-vsatc-preorder] [data-vsatc-btn]');
    if (stickyPreorder) {
      const input = document.querySelector('[data-preorder-ack]');
      if (input instanceof HTMLInputElement && !requireAcknowledgment(input)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      return;
    }

    const preorderSubmit = target.closest('[ref="addToCartButton"], .add-to-cart-button, button[name="add"], [data-preorder-submit]');
    if (preorderSubmit) {
      const form = preorderSubmit.closest('form');
      const input = form?.querySelector('[data-preorder-ack]');
      if (input instanceof HTMLInputElement && !requireAcknowledgment(input)) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
    }

    if (isPreorderPage() && target.closest(PROMO_SELECTOR)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      syncPreorderPromoGuard();
      return;
    }

    const checkout = target.closest('[data-preorder-checkout]');
    if (!checkout) return;
    const cartRoot = checkout.closest('cart-items-component') || document;
    const input = cartRoot.querySelector('[data-preorder-cart-ack]');
    if (input instanceof HTMLInputElement && !requireAcknowledgment(input)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  function boot() { initialize(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();

  document.addEventListener('cart:update', boot, true);
  document.addEventListener('variant:update', () => setTimeout(boot, 0), true);
  window.addEventListener('pageshow', boot);

  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node instanceof Element) initialize(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Velario: native sticky add-to-cart must respect the pre-order terms (added 2026-11-02). */
(() => {
  const STICKY_BTN = 'sticky-add-to-cart [ref="addToCartButton"]';
  const ADD_RE = /add to cart|añadir al carrito|agregar al carrito/i;
  const isEs = () => (document.documentElement.lang || '').indexOf('es') === 0;
  const isPreorder = () => !!document.querySelector('[data-preorder-panel]');

  function relabelSticky() {
    if (!isPreorder()) return;
    const label = isEs() ? 'Reservar · preventa' : 'Pre-order now';
    document.querySelectorAll(STICKY_BTN).forEach((btn) => {
      const walker = document.createTreeWalker(btn, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (ADD_RE.test(node.nodeValue)) node.nodeValue = node.nodeValue.replace(ADD_RE, label);
      }
      btn.setAttribute('aria-label', label);
    });
  }

  /* Window capture runs before Horizon's document-level click delegation, so an unticked box stops the dead puppet click. */
  window.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element) || !target.closest(STICKY_BTN) || !isPreorder()) return;
    const ack = document.querySelector('[data-preorder-ack]');
    if (!(ack instanceof HTMLInputElement) || ack.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const panel = ack.closest('[data-preorder-panel]');
    const row = ack.closest('[data-preorder-consent-row]');
    const error = panel ? panel.querySelector('[data-preorder-error]') : null;
    if (error instanceof HTMLElement) {
      error.textContent = isEs()
        ? 'Marca la casilla para confirmar las condiciones de preventa.'
        : 'Please check the box to confirm the pre-order terms.';
      error.hidden = false;
    }
    if (row instanceof HTMLElement) row.classList.add('is-error');
    (row || ack).scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => ack.focus({ preventScroll: true }), 450);
  }, true);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', relabelSticky, { once: true });
  else relabelSticky();
  document.addEventListener('variant:update', () => setTimeout(relabelSticky, 0), true);
  document.addEventListener('cart:update', relabelSticky, true);
  window.addEventListener('pageshow', relabelSticky);
})();
